import { compose } from 'redux';
import { connect } from 'react-redux';
import LayoutModule from 'app/store/layout';
import NewsletterModule from 'app/store/newsletter';
import withFormValidation from 'app/HOC/withFormValidation';
import Newsletter from './Newsletter.component';
import schema from './Newsletter.schema';

const { createToast } = LayoutModule.actions;
const { sendNewsletterRegistrationRequest } = NewsletterModule.actions;

const mapStateToProps = ({ information: { legalInfoContent }, newsletter }) => ({
  legalInfo: legalInfoContent.slice(),
  newsletterResult: newsletter.newsletterRegistration[0]
});

const mapDispatchToProps = {
  notify: createToast,
  sendNewsletterRegistration: sendNewsletterRegistrationRequest
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFormValidation(schema)
)(Newsletter);
